/* Package imports */
import { useEffect, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

/* Utility imports */
import { changeBodyAttribute } from '../constants/global';

/* Default loading component */
const loading = () => <div className=""></div>;

const DefaultLayout = (props) => {

    const { layoutColor } = useSelector((state) => ({
        layoutColor: state.layout.layoutColor,
    }));

    useEffect(() => {
        changeBodyAttribute('data-layout-color', layoutColor);
    }, [layoutColor]);

    useEffect(() => {
        if (document.body) document.body.classList.add('authentication-bg');

        return () => {
            if (document.body) document.body.classList.remove('authentication-bg');
        };
    }, []);

    return (
        <Suspense fallback={loading()}>
            <Outlet />
        </Suspense>
    );
};

export default DefaultLayout;
